module.exports = __webpack_public_path__ + "06b6aebeff8dffd056617b4666f3c462.svg";